import { INVALID_1000 } from "./consts";
const ADM_ZIP = window.require("adm-zip");
const iconv = window.require("iconv-lite");
const os = window.require("os");
export const isDefined = (v) => {
  return v !== null && v !== undefined;
};
export const isNotDefined = (v) => {
  return v === undefined || v == null;
};
export const hasKey = (obj, key) => {
  return key.split(".").every((x) => {
    if (typeof obj !== "object" || obj === null || !(x in obj)) {
      return false;
    } else {
      obj = obj[x];
      return true;
    }
  });
};
// 将buf转换成字符串
export const encodeStr = (s, encode) => {
  if (isDefined(s) && !isStringEmpty(s)) {
    let buf = Buffer.from(s);
    return iconv.encode(buf, encode);
  }
};
// 将字符串转换成buffer
export const decodeStr = (s, encode) => {
  if (isDefined(s) && !isStringEmpty(s)) {
    let buf = Buffer.from(s);
    return iconv.decode(buf, encode);
  }
};
export const zip = (src, dst) => {
  const zip = new ADM_ZIP();
  zip.addLocalFolder(src);
  zip.writeZip(dst);
};
export const unZip = (src, dst) => {
  const unZip = new ADM_ZIP(src);
  unZip.extractAllTo(dst, /* overwrite */ true);
};
export const getKey = (obj, key) => {
  return key.split(".").reduce((o, x) => {
    return typeof o === "undefined" || o === null ? o : o[x];
  }, obj);
};
export const logTime = (str) => {
  let date = new Date();
  console.log(`${str}: ${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`);
};
export const logStdout = function () {
  let logName = arguments[0];
  if (!isDefined(logName)) {
    throw new Error("Log name is needed!");
  }
  let content = "";
  for (let id = 1; id < arguments.length; id++) {
    let arg = arguments[id];
    if (isObject(arg)) {
      content += json2string(arg) + ";";
    } else if (isString(arg) && !isStringEmpty(arg)) {
      content += arg + ";";
    } else if (isNumber(arg)) {
      content += arg + ";";
    }
  }
  let str = `[${getSystemTime("/", " ", ":", true)}] [${logName}]: ${content}`;
  console.log(str.replace(/;$/gi, ""));
};
export const isLocalServer = () => {
  return window.server.serverip === "127.0.0.1" || window.server.serverip === "localhost";
};
export const isNumberString = (v) => {
  return (
    typeof v === "string" &&
    !isStringEmpty(v) &&
    /^[-+]?(([0-9]+)([.]([0-9]+))?|([.]([0-9]+))?)$/.test(v)
  );
};
export const toNumber = (v) => {
  if (typeof v === "number") return v;
  let n = parseFloat(v);
  return isNaN(n) ? INVALID_1000 : n;
};
// 检查当前配置文件中相对于程序默认配置缺失的字段
export const checkCfg = () => {
  let ckstat = false;
  return function _checkCfg(confInJson, confNew) {
    for (let id in confNew) {
      if (Array.isArray(confNew[id])) {
        if (!isDefined(confInJson[id])) confInJson[id] = [];
        _checkCfg(confInJson[id], confNew[id]);
      } else if (confNew[id] instanceof Object) {
        if (!isDefined(confInJson[id])) confInJson[id] = {};
        _checkCfg(confInJson[id], confNew[id]);
      } else {
        if (!isDefined(confInJson[id])) {
          ckstat = true;
          confInJson[id] = confNew[id];
        }
      }
    }
    return ckstat;
  };
};
export const isStringEmpty = (str) => {
  return str === "";
};
export const isFunction = (f) => {
  return isDefined(f) && typeof f === "function";
};
export const isTrue = (v) => {
  return v === true;
};
export const string2json = (v) => {
  try {
    return JSON.parse(v);
  } catch (e) {
    return null;
  }
};
export const json2string = (o) => {
  try {
    return JSON.stringify(o);
  } catch (e) {
    return null;
  }
};
export const isObject = (o) => {
  return isDefined(o) && typeof o === "object";
};
export const isPlainObject = (o) => {
  return Object.prototype.toString.call(o) === "[object Object]";
};
export const cloneObj = (o) => {
  return objectCopy(o);
};
export const isArray = (arr) => {
  return Array.isArray(arr);
};
export const objectCopy = (o) => {
  return string2json(json2string(o));
};
export const isArrayEmpty = (arr) => {
  return !(Array.isArray(arr) && arr.length > 0);
};
// 对象深拷贝
export const deepCopy = (o) => {
  let oCopy = isArray(o) ? [] : {};
  for (let k in o) {
    if (o.hasOwnProperty(k)) {
      if (isPlainObject(o[k])) {
        oCopy[k] = deepCopy(o[k]);
      } else {
        oCopy[k] = o[k];
      }
    }
  }
  return oCopy;
};

export const getObjectLength = (o) => {
  if (!isPlainObject(o)) {
    throw new Error("isEmptyObject function: o should be a plain object");
  }
  return Object.keys(o).length;
};

export const isEmptyObject = (o) => {
  if (!isPlainObject(o)) {
    throw new Error("isEmptyObject function: o should be a plain object");
  }
  return isObject(o) && getObjectLength(o) < 1;
};
export const isString = (s) => {
  return isDefined(s) && typeof s === "string";
};
export const isNumber = (n) => {
  return isDefined(n) && typeof n === "number";
};
export const isEqual = (v1, v2) => {
  return isNumber(v1) && isNumber(v2) && Math.abs(v1 - v2) < 0.00000001;
};
export const isNumNotNanOrInfinite = (v) => {
  return typeof v === "number" ? !isNaN(v) && isFinite(v) : false;
};
export const canConvertNumber = (s) => {
  return isDefined(s) && s !== "" && !isNaN(Number(s));
};
export const isDataValid = (v, invalid = INVALID_1000) => {
  if (!isDefined(v)) return false;
  if (typeof v === "string" && isNumberString(v)) {
    if (v === "") return false;
    let val = parseFloat(v);
    return !isEqual(val, invalid);
  } else if (typeof v === "number") {
    if (isNumNotNanOrInfinite(v) && !isEqual(v, invalid)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const getImageUrl = (filename, servercfg, token) => {
  const { serverip, serverport, sslport, serverssl } = servercfg || {};
  if (isDefined(filename)) {
    let protocol = serverssl === 1 ? "https" : "http";
    let port = serverssl === 1 ? sslport : serverport;
    return `${protocol}://${serverip}:${port}/media/${filename}?access_token=${token}`;
  } else {
    return "";
  }
};
// 判读程序是否处在Electron环境下
export const isElectron = () => {
  if (isDefined(window) && isObject(window.process) && window.process.type === "render") {
    return true;
  }
  if (isDefined(process) && isObject(process.versions) && !!process.versions.electron) {
    return true;
  }
  if (
    isObject(navigator) &&
    isString(navigator.userAgent) &&
    navigator.userAgent.includes("Electron")
  ) {
    return true;
  }
  return false;
};
export const jsGetAge = (strBirthday) => {
  var returnAge;
  if (!isDefined(strBirthday) || isStringEmpty(strBirthday)) return -1;
  var strBirthdayArr = strBirthday.split("-");
  var birthYear = parseInt(strBirthdayArr[0]);
  var birthMonth = parseInt(strBirthdayArr[1]);
  var birthDay = parseInt(strBirthdayArr[2]);
  var date = new Date();
  var nowYear = date.getFullYear();
  var nowMonth = date.getMonth() + 1;
  var nowDay = date.getDate();
  if (nowYear === birthYear) {
    returnAge = 0; // 同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear; // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay; // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth; // 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; // 返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge; // 返回周岁年龄
};
export const getSystemTime = (spDate = "-", spDT = " ", spTime = ":", includeMillSec = false) => {
  let date = new Date();
  let year = date.getFullYear();
  let month = `${date.getMonth() + 1}`;
  let day = `${date.getDate()}`;
  let hour = `${date.getHours()}`;
  let min = `${date.getMinutes()}`;
  let sec = `${date.getSeconds()}`;
  let millsec = `${date.getMilliseconds()}`;
  month = month.padStart(2, "0");
  day = day.padStart(2, "0");
  hour = hour.padStart(2, "0");
  min = min.padStart(2, "0");
  sec = sec.padStart(2, "0");
  let ymd = [year, month, day].join(spDate);
  let hms = (includeMillSec ? [hour, min, sec, millsec] : [hour, min, sec]).join(spTime);
  return `${ymd}${spDT}${hms}`;
};
export const normalName = (fn, ln) => {
  return isDefined(ln) && ln !== "" ? `${fn}, ${ln}` : fn;
};

export const testSpecialChar = (s) => {
  let reg = /[`~!￥#$%^&*()_+<>?——:="{}/：；【】…'[\]]/gim;
  return reg.test(s);
};
export const initArray = (num, fillval) => {
  let val = isDefined(fillval) ? fillval : INVALID_1000;
  let initArr = Array(num);
  initArr.fill(val);
  return initArr.concat();
};
export const getFullName = (patient) => {
  if (isDefined(patient)) {
    if (isDefined(patient.lastname) && !isStringEmpty(patient.lastname)) {
      return `${patient.firstname}, ${patient.lastname}`;
    } else {
      return patient.firstname;
    }
  }
  return "";
};
export const isGreater = (v, th) => {
  return Math.abs(v) > th;
};
export const isWindows = () => {
  return os.platform() === "win32";
};
export const isLinux = () => {
  return os.platform() === "linux";
};
isLinux();

export const command = (cmd) => {
  return `${cmd}`;
};

export const isNewPupilCorneadia = (record, currentEye) => {
  if (
    record.content[`data${currentEye}`].pupilcorneadia_dark ||
    record.content[`data${currentEye}`].pupilcorneadia_bright ||
    record.content[`data${currentEye}`].pupilcorneadia_dynamic ||
    record.content[`data${currentEye}`].pupilcorneadia_lowerMiddle ||
    record.content[`data${currentEye}`].pupilcorneadia_middle
  ) {
    return true;
  }
  if (record.content[`data${currentEye}`].pupilcorneadia) {
    return false;
  }
  return false;
};

export const getPupilCorneadiaKey = (record, currentEye) => {
  if (
    record.content[`data${currentEye}`].pupilcorneadia_dark ||
    record.content[`data${currentEye}`].pupilcorneadia_bright ||
    record.content[`data${currentEye}`].pupilcorneadia_lowerMiddle ||
    record.content[`data${currentEye}`].pupilcorneadia_middle
  ) {
    if (record.content[`data${currentEye}`].pupilcorneadia_dark) {
      return `content.data${currentEye}.pupilcorneadia_dark.corneadia.edge.r`;
    }
    if (record.content[`data${currentEye}`].pupilcorneadia_bright) {
      return `content.data${currentEye}.pupilcorneadia_bright.corneadia.edge.r`;
    }
    if (record.content[`data${currentEye}`].pupilcorneadia_lowerMiddle) {
      return `content.data${currentEye}.pupilcorneadia_lowerMiddle.corneadia.edge.r`;
    }
    if (record.content[`data${currentEye}`].pupilcorneadia_middle) {
      return `content.data${currentEye}.pupilcorneadia_middle.corneadia.edge.r`;
    }
  }
  if (record.content[`data${currentEye}`].pupilcorneadia) {
    return `content.data${currentEye}.pupilcorneadia.corneadia.edge.r`;
  }
  return `content.data${currentEye}.pupilcorneadia.corneadia.edge.r`;
};



// WEBPACK FOOTER //
// ./src/shared/utils.js